import PageHero from "../components/PageHero";
import FeaturedProjects from "../components/sections/FeaturedProjects";
import SiteVisitCTA from "../components/sections/SiteVisitCTA";

export default function ProjectsPage({ onOpenLead }) {
  return (
    <div data-testid="projects-page">
      <PageHero
        eyebrow="Our Projects"
        title="High-potential investment portfolios."
        subtitle="A curated showcase of Dholera Smart City projects across residential, commercial and large land categories."
        image="https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2070&auto=format&fit=crop"
      />
      <FeaturedProjects onOpenLead={onOpenLead} />
      <SiteVisitCTA />
    </div>
  );
}
